import React, { useState, useEffect, useRef } from "react";

import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { getMonthlyInventoryData } from "../../../Redux/actions/monthlyInventoryActions";
import {
  setProductInventory,
  setProductInventoryWithLocation,
} from "../../../Redux/actions/inventoryActions";
import {
  getInBranchItems,
  setMonthlyInventory,
  updateMonthlyInventory,
} from "../../../Redux/actions/monthlyInventoryActions";

import { numberWithCommas } from "../../../utils/helpers";
import ExporThisAudit from "../exports/MonthlyAuditExport";
import EditAuditItemModal from "../EditAuditItemModal";

import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";

const { Panel } = Collapse;

const Index = ({ thisrecord, currentlatest, onModalClose }) => {
  const dispatch = useDispatch();
  const { branchitems, user } = useSelector(
    (state) => ({
      branchitems: state.monthlyInventory.branchitems,
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalVal, setTotalVal] = useState(0);

  const [currentWeighted, setCurrentWeighted] = useState(0);

  useEffect(() => {
    getcurrentrate();
  }, []);
  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };

  useEffect(() => {
    if (thisrecord.audited_items) {
      // console.log(record)
      docategorized(thisrecord.audited_items);
    }
  }, [thisrecord]);

  const docategorized = (itemstobecategoriized) => {
    var categories = [];

    itemstobecategoriized.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    var newTotal = 0;
    var newTotalVal = 0;

    categories.map((ct) => {
      var catprods = [];
      var cat_total_peso = 0;
      var cat_total_peso_val = 0;

      itemstobecategoriized.map((it) => {
        if (ct == it.category_name) {
          var difference = parseFloat(it.new_count) - parseFloat(it.old_count);

          var peso_diff = 0;
          var peso_val = 0;

          if (it.regionalization == "local") {
            peso_diff = parseFloat(difference) * parseFloat(it.cost_peso);
            peso_val = parseFloat(it.new_count) * parseFloat(it.cost_peso);
          } else {
            if (it.cost_rmb) {
              peso_diff =
                parseFloat(difference) *
                parseFloat(it.cost_rmb) *
                parseFloat(thisrecord.weighted_exchange);
              peso_val =
                parseFloat(it.new_count) *
                parseFloat(it.cost_rmb) *
                parseFloat(thisrecord.weighted_exchange);
            }
          }

          var percent_diff = 0;

          if (parseFloat(it.old_count) != 0 && it.old_count) {
            percent_diff = (difference / parseFloat(it.old_count)) * 100;
          }

          var newitem = {
            ...it,
            qty_diff: numberWithCommas(parseFloat(difference).toFixed(3)),
            percent_diff: numberWithCommas(parseFloat(percent_diff).toFixed(3)),
            peso_diff: numberWithCommas(parseFloat(peso_diff).toFixed(2)),
            peso_val: numberWithCommas(parseFloat(peso_val).toFixed(2)),
          };
          if (peso_diff) {
            cat_total_peso = parseFloat(cat_total_peso) + parseFloat(peso_diff);
            newTotal = parseFloat(newTotal) + parseFloat(peso_diff);
          }

          if (peso_val) {
            cat_total_peso_val =
              parseFloat(cat_total_peso_val) + parseFloat(peso_val);
            newTotalVal = parseFloat(newTotalVal) + parseFloat(peso_val);
          }

          catprods.push(newitem);
        }
      });
      setTotalLoss(newTotal);
      setTotalVal(newTotalVal);
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
        cat_total_peso: cat_total_peso,
        cat_total_peso_val: cat_total_peso_val,
      };
      newcats.push(newcatp);
    });
    // console.log(newcats)
    setCategorized(newcats);
  };

  const approveAllinCollapse = async (pendingrecords) => {
    var currentAudit = thisrecord;
    console.log(pendingrecords);
    if (!loading) {
      setLoading(true);
      message.info("recording audit change");

      var pending_ids = pendingrecords.map((item) => {
        return item.id;
      });

      var audit_items = currentAudit.audited_items;
      var new_audit_items = [];
      for (let index = 0; index < audit_items.length; index++) {
        var item = audit_items[index];

        var newitem = {
          ...item,
        };

        if (pending_ids.includes(item.id)) {
          var itemsum = 0;
          var itemcount = null;
          var itemcount2 = null;
          if (item.requested_main_unit_input) {
            itemcount = item.requested_main_unit_input;
          }
          if (item.requested_second_unit_input) {
            itemcount2 = item.requested_second_unit_input;
          }

          if (itemcount) {
            itemsum = itemsum + parseFloat(itemcount);
            newitem["main_unit_input_new"] = parseFloat(itemcount);
          }
          if (itemcount2) {
            itemsum =
              itemsum +
              parseFloat(itemcount2) * parseFloat(item.second_unit_rate);
            newitem["second_unit_input_new"] = parseFloat(itemcount2);
          }
          newitem["requested_status"] = "completed";
          newitem["new_count"] = itemsum;
          newitem["updated_at"] = moment().format("YYYY-MM-DD HH:mm:ss");
          newitem["updated_by"] = user.id;
          newitem["updated_name"] = user.name;

          var product3 = await dispatch(
            setProductInventoryWithLocation(
              item.id,
              item.name,
              itemsum,
              "change",
              "audit changed",
              currentAudit.branch,
              currentAudit.branch_name
            )
          );
        }

        new_audit_items.push(newitem);
      }

      var new_audit = {
        ...currentAudit,
        audited_items: new_audit_items,
      };

      var newsold = await dispatch(updateMonthlyInventory(new_audit));

      setLoading(false);
      onModalClose("reset");
    }
  };

  const renderTable = (currentgroup) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",

        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: ["descend", "ascend"],

        search: "name",
        render: (text, record, index) => {
          return <div className="smoltxt">{text}</div>;
        },
      },
      {
        title: "Old Count",
        dataIndex: "old_count",
        key: "old_count",
        render: (text, record, index) => {
          return (
            <div className="smoltxt">
              {numberWithCommas(parseFloat(text).toFixed(2))}
            </div>
          );
        },
      },
      {
        title: "New Count",
        dataIndex: "new_count",
        key: "new_count",
        render: (text, record, index) => {
          return (
            <div className="smoltxt vertical-flex">
              <span>{numberWithCommas(parseFloat(text).toFixed(2))}</span>

              <span>
                {record?.requested_status == "pending"
                  ? `(${numberWithCommas(
                      parseFloat(record?.requested_count).toFixed(2)
                    )})`
                  : null}
              </span>
            </div>
          );
        },
      },
      {
        title: "Unit",
        dataIndex: "unit",
        key: "unit",
      },
      {
        title: "Difference",
        dataIndex: "qty_diff",
        key: "qty_diff",
        render: (text, record, index) => {
          return (
            <div
              className={`smoltxt ${parseFloat(text) < 0 ? "red-text" : ""} ${
                parseFloat(text) > 0 ? "green-text" : ""
              }`}
            >
              {text}
            </div>
          );
        },
      },
    ];

    const filterColumn = () => {
      var newColumns = columns;
      const moneycol = [
        {
          title: "Percent Diff",
          dataIndex: "percent_diff",
          key: "percent_diff",
          render: (text, record, index) => {
            return (
              <div
                className={`smoltxt ${parseFloat(text) < 0 ? "red-text" : ""} ${
                  parseFloat(text) > 0 ? "green-text" : ""
                }`}
              >
                {text} %
              </div>
            );
          },
        },
        {
          title: "Peso Diff",
          dataIndex: "peso_diff",
          key: "peso_diff",
          render: (text, record, index) => {
            return (
              <div
                className={`smoltxt ${parseFloat(text) < 0 ? "red-text" : ""} ${
                  parseFloat(text) > 0 ? "green-text" : ""
                }`}
              >
                ₱ {text}
              </div>
            );
          },
        },
        {
          title: "Peso Val",
          dataIndex: "peso_val",
          key: "peso_val",
          render: (text, record, index) => {
            return (
              <div
                className={`smoltxt ${parseFloat(text) < 0 ? "red-text" : ""} ${
                  parseFloat(text) > 0 ? "green-text" : ""
                }`}
              >
                ₱ {text}
              </div>
            );
          },
        },
      ];

      if (user.role == "admin") {
        newColumns = newColumns.concat(moneycol);
      }

      const editpart = [
        {
          title: "Edit",
          width: 50,
          render: (text, record, index) => {
            return (
              <div>
                <EditAuditItemModal
                  onModalClose={(action) => {
                    onModalClose(action);
                  }}
                  thisItem={record}
                  thisAudit={thisrecord}
                />
              </div>
            );
          },
        },
      ];

      // if((thisrecord?.id == currentlatest?.id && !currentlatest?.checked_at) &&
      if (user.role == "admin") {
        newColumns = newColumns.concat(editpart);
      }

      return newColumns;
    };

    var pending_existing = false;
    var pendingrecords = [];
    currentgroup.products.map((record) => {
      if (record.requested_status == "pending") {
        pending_existing = true;
      }
      pendingrecords.push(record);
    });

    // console.log(pendingrecords)

    const collapseheader = () => {
      return (
        <div className="collapseheader">
          <span className="spancont">{currentgroup.category}</span>
          {user.role == "admin" ? (
            <span className="spancont">
              {`Value: Php ${numberWithCommas(
                parseFloat(currentgroup.cat_total_peso_val).toFixed(2)
              )} `}
            </span>
          ) : null}
          {user.role == "admin" ? (
            <span
              className={`spancont ${
                parseFloat(currentgroup.cat_total_peso) < 0 ? "red-text" : ""
              }`}
            >
              {`Loss: Php ${numberWithCommas(
                parseFloat(currentgroup.cat_total_peso).toFixed(2)
              )} `}
            </span>
          ) : null}
          {pending_existing ? (
            <span className={`spancont `}>
              <Button
                type="primary"
                onClick={() => {
                  approveAllinCollapse(pendingrecords);
                }}
                disabled={loading}
              >
                {loading ? "Loading" : "Approve All"}
              </Button>
            </span>
          ) : null}
        </div>
      );
    };

    return (
      <Collapse className={"category_containter"}>
        <Panel
          header={collapseheader()}
          key="1"
          className={pending_existing ? "row_background_warning" : ""}
        >
          <Table
            columns={filterColumn()}
            dataSource={currentgroup.products}
            pagination={false}
            rowClassName={(record, index) => {
              if (record.requested_status == "pending") {
                return "row_background_warning";
              }
            }}
            // showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  return (
    <>
      {categorized.length > 0 ? (
        <div className="audit_item-content">
          {user.role == "admin" ? (
            <div className="space_it_out">
              <h4>
                Total Loss (Php):{" "}
                {numberWithCommas(parseFloat(totalLoss).toFixed(2))}{" "}
              </h4>
              <h4>
                Total Val (Php):{" "}
                {numberWithCommas(parseFloat(totalVal).toFixed(2))}{" "}
              </h4>

              <ExporThisAudit
                values={thisrecord}
                weighted_exchange={thisrecord.weighted_exchange}
              />
            </div>
          ) : null}

          {categorized.map((cat) => {
            return renderTable(cat);
          })}
        </div>
      ) : null}
    </>
  );
};

export default Index;
